import { call } from 'redux-saga/effects'

import { socket } from '../socket'

export function* close() {
  yield call(console.info, 'socket close')

  socket.off('connect')
  socket.off('disconnect')

  socket.io.off('open')
  socket.io.off('reconnect_failed')

  socket.close()
}
